import pushClevertapEvent from '../pushClevertapEvent';

export function accountSettingsOpenPaymentMethod() {
  pushClevertapEvent('Setting Payment Method');
}
